import * as React           from 'react';
import FunctionalitiesGrid from "../../components/bo-core/grids/FunctionalitiesGrid/FunctionalitiesGrid";

class Functionalities extends React.Component {
    render() {
        return (
            <div style={{backgroundColor: '#2B2B2B', height: '100%'}}>
                <FunctionalitiesGrid/>
            </div>
        );
    }
}
export default Functionalities



// WEBPACK FOOTER //
// ./app/views/bo-core/Functionalities.tsx